import { sendRequest } from '../../utils/http-request';

export async function redirectToCreditCardPaymentPortal(
  loginAccountNumber: string,
  electricityReferenceNumber?: string,
  gasReferenceNumber?: string
) {
  return sendRequest(
    'post',
    `/billing/direct-debit/${loginAccountNumber}/credit-card-session`,
    {
      electricityReferenceNumber,
      gasReferenceNumber,
    }
  );
}

export async function validateBsbNumber(bsbNumber: string) {
  return sendRequest('get', `/business/bsb/${bsbNumber}`);
}
